// Generate a unique correlation_id for tagular events.

const getCorrelationId = () => {
  return Math.round(Math.random() * 10000000).toString() + new Date().getTime()
}

module.exports = getCorrelationId
